import clsx from 'clsx'
import { StencilCDNImage } from '@/components/Common/StencilImage'

type TStrapiV4ImageComponentProps = {
  // id: number
  alt: string
  img: string
  rounded?: boolean
  verticalBuffer?: boolean
  width?: number
  height?: number
  transformCircle?: boolean
  priority?: boolean
}

export function StrapiV4Image(props: TStrapiV4ImageComponentProps) {
  const {
    alt,
    img,
    rounded,
    verticalBuffer = true,
    width,
    height,
    transformCircle,
    priority,
  } = props

  if (!img) return null

  return (
    <StencilCDNImage
      alt={alt}
      src={img}
      width={width ?? 100}
      height={height ?? 100}
      priority={priority ?? false}
      className={clsx('object-contain', {
        'rounded-3xl': rounded,
        'my-6': verticalBuffer,
        'rounded-full': transformCircle,
      })}
    />
  )

  return null
}
